import React from 'react';
import { Heading } from 'components';
import { SectionStyled } from './layout.styled';

interface SectionProps {
  title?: string;
  children?: React.ReactNode | React.ReactNode[];
}

export const Section = ({ title, children }: SectionProps) => {
  return (
    <SectionStyled>
      {title ? (
        <Heading level={2} size='medium'>
          {title}
        </Heading>
      ) : null}
      {children}
    </SectionStyled>
  );
};
